import { module } from 'modujs'

export default class extends module {
  constructor(m) {
    super(m)

    this.copyBtn = this.el.querySelector('.sharer__copy')
    this.copyDuring = 1500
    this.text = ''
    this.copied = false
    this.btnTextDefault = this.copyBtn?.dataset.labelCopy ?? 'Copy link'
    this.btnTextCopied = this.copyBtn?.dataset.labelCopied ?? 'Copied!'

    if (navigator && 'clipboard' in navigator) {
      this.copyBtn.addEventListener('click', this.clickedCopyBtn)
    }
    else {
      this.copyBtn.remove()
    }
  }

  clickedCopyBtn() {
    this.copy(window.location.href)
  }

  async copy(value) {
    if (!value) {
      return
    }

    try {
      await navigator.clipboard.writeText(value)

      this.isCopiedText(value)
    }
    catch (error) {
      this.resetCopy()

      console.error(error.message)
    }
  }

  isCopiedText(value) {
    this.text = value
    this.copied = true
    this.copyBtn.textContent = this.btnTextCopied

    setTimeout(this.resetCopy.bind(this), this.copyDuring)
  }

  resetCopy() {
    this.text = ''
    this.copied = false
    this.copyBtn.textContent = this.btnTextDefault
  }

  destroy() {
    this.copyBtn.removeEventListener('click', this.clickedCopyBtn)
  }
}
